import { create } from "zustand";

const useConfettiStore = create((set) => ({
  active: false,

  fireConfetti: () => set({ active: true }),

  clearConfetti: () => set({ active: false }),
}));

export const useFireConfetti = () => useConfettiStore((s) => s.fireConfetti);

export const useConfettiActive = () => useConfettiStore((s) => s.active);

export const useClearConfetti = () => useConfettiStore((s) => s.clearConfetti);

export default useConfettiStore;
